import * as React from 'react'

import { cn } from '@/shared/lib/utils'

interface SidePanelSectionProps extends React.ComponentPropsWithoutRef<'section'> {
  separated?: boolean
  compact?: boolean
}

export const SidePanelSection = React.forwardRef<HTMLDivElement, SidePanelSectionProps>(
  ({ className, separated = true, compact = false, ...props }, ref) => (
    <section
      ref={ref}
      className={cn(
        'px-3',
        compact ? 'py-2' : 'py-3',
        separated && 'border-b border-border',
        className
      )}
      {...props}
    />
  )
)
SidePanelSection.displayName = 'SidePanelSection'

interface SidePanelSectionBodyProps extends React.ComponentPropsWithoutRef<'div'> {}

export const SidePanelSectionBody = React.forwardRef<HTMLDivElement, SidePanelSectionBodyProps>(
  ({ className, ...props }, ref) => (
    <div ref={ref} className={cn('flex flex-col gap-3', className)} {...props} />
  )
)
SidePanelSectionBody.displayName = 'SidePanelSectionBody'
